import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { StorageService } from 'src/app/services/storage.service';
import _ from 'lodash';
import { Storage } from 'src/app/models/storage';
import { SYSTEM } from '../../data/system';

@Component({
  selector: 'app-system-type',
  templateUrl: './system-type.component.html',
})
export class SystemTypeComponent implements OnInit {
  form: FormGroup;
  subscription: Subscription;
  storage: Storage;

  showMoreId = null;
  showLessId = null;
  show: boolean[] = [null, null, null];

  readonly SYSTEM = SYSTEM;

  constructor(
    private fb: FormBuilder,
    private storageService: StorageService,
  ) { }

  ngOnInit() {
    this.storage = this.storageService.storage;

    this.form = this.fb.group({
      systemType: [
        this.storage.systemType,
        [
          Validators.required
        ]
      ],
    });

    this.storageSubscription();
    this.onFormChange();
  }

  private storageSubscription() {
    this.subscription = this.storageService.storage$.subscribe(async (data) => {
      this.storage = data;

      this.onFormPatchValues();
    });
  }

  private onFormPatchValues() {
    const formValues = {};
    _.forEach(this.form.getRawValue(), (value, prop) => {
      formValues[prop] = this.storage[prop];
    });

    this.form.patchValue(
      formValues, {
      emitEvent: false
    });
  }

  private onFormChange() {
    this.form.valueChanges.subscribe((field) => {
      _.merge(this.storage, field);
    });
  }

  showMore(id) {
    if (this.show[id] === true) {
      this.show[id] = null;
    } else {
      this.show[id] = true;
    }
  }

  showLess(id) {
    if (this.show[id] === false) {
      this.show[id] = null;
    } else {
      this.show[id] = false;
    }
  }
}
